import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ProductListPage from "../components/CreateProductListLayer";
import { useSelector } from "react-redux";

const CreateProductList = () => {
  const isEdit = useSelector((state) => state.product.isEdit);
  const pageTitle = isEdit ? "Edit Product" : "Create Product";

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title={pageTitle} header={pageTitle} />

        {/* ProductListLayer */}
        <ProductListPage />
      </MasterLayout>
    </>
  );
};

export default CreateProductList;
